import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const current = this.inputTarget.value
    if (current) this.highlightColor(current)
  }

  select(event) {
    const btn = event.currentTarget
    const color = btn.dataset.color
    if (!color) return

    this.inputTarget.value = color
    this.highlightColor(color)
  }

  highlightColor(color) {
    this.element.querySelectorAll("button[data-color]").forEach(btn => {
      if (btn.dataset.color === color) {
        btn.classList.remove("ring-transparent")
        btn.classList.add("ring-primary-500", "ring-offset-2")
        btn.innerHTML = '<i class="fa-solid fa-check text-white text-sm drop-shadow" aria-hidden="true"></i>'
        btn.classList.add("flex", "items-center", "justify-center")
      } else {
        btn.classList.add("ring-transparent")
        btn.classList.remove("ring-primary-500", "ring-offset-2")
        btn.innerHTML = ""
        btn.classList.remove("flex", "items-center", "justify-center")
      }
    })
  }
}
